module.exports = __webpack_public_path__ + "static/media/05-atoz.7092976a.png";